import {
  RiAddLargeFill,
  RiCloseLargeFill,
  RiDeleteBin6Line,
} from "react-icons/ri";
import DynamicSelect from "../DynamicSelect";
import { useEffect, useState, useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import { format } from "date-fns";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import AddMedicineModal from "../AddMedicalModal";
import CreatableSelect from "react-select/creatable";
import { useAuth } from "../../utils/AuthContext";

const API_BASE = "https://api.muktihospital.com/api/medicine-purchase";
const SUPPLIER_API = "https://api.muktihospital.com/api/medicine-supplier";
const MEDICINE_CATEGORY_API = "https://api.muktihospital.com/api/pharmacy-category";
const MEDICINE_API = "https://api.muktihospital.com/api/medicine";
const MEDICINE_GROUP_API = "https://api.muktihospital.com/api/medicine-group";
const MEDICINE_COMPANY_API = "https://api.muktihospital.com/api/medicine-company";
const MEDICINE_UNIT_API = "https://api.muktihospital.com/api/pharmacy-unit";
const API_KEY = "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079";
const AUTHORITIES_API_URL = "https://api.muktihospital.com/api/authorities";

const PurchaseMedicineModal = ({ isOpen, onClose, purchaseId, onSave }) => {
  const { user } = useAuth();

  const [userName, setUserName] = useState(user?.name || "Unknown User");
  const [userPhone, setUserPhone] = useState(user?.mobile || "Unknown Mobile");

  const [image, setImage] = useState(null);
  const [existingDocumentUrl, setExistingDocumentUrl] = useState("");

  const [formData, setFormData] = useState([
    {
      medicineCategory: "",
      medicineName: "",
      batchNo: "",
      expiryDate: "",
      boxQty: 0,
      unitPerBox: 0,
      quantity: 0,
      supplierPrice: 0,
      boxPrice: 0,
      amount: 0,
      price: 0,
    },
  ]);
  const [supplierId, setSupplierId] = useState("");
  const [billNo, setBillNo] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [discount, setDiscount] = useState(0);
  const [tax, setTax] = useState(0);
  const [paymentMode, setPaymentMode] = useState("cash");
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [hasEditedPaymentAmount, setHasEditedPaymentAmount] = useState(false);
  const [netAmount, setNetAmount] = useState(0);
  const [returnAmount, setReturnAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);
  const [paymentNotes, setPaymentNotes] = useState("");
  const [categories, setCategories] = useState({ options: [] });
  const [rawMedicines, setRawMedicines] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [units, setUnits] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [addMedicineModalOpen, setAddMedicineModalOpen] = useState(false);
  const [authorizedByOptions, setAuthorizedByOptions] = useState([]);
  const [authorizedBy, setAuthorizedBy] = useState("");
  const [errors, setErrors] = useState({});
  const paymentModes = [
    { value: "cheque", label: "Cheque" },
    { value: "cash", label: "Cash" },
    { value: "card", label: "Card" },
    { value: "upi", label: "UPI" },
  ];
// Retry logic for failed requests
const axiosInstance = axios.create({
  timeout: 5000,
});

// Retry logic for failed requests
const retryRequest = async (config, maxRetries = 3, delay = 1000) => {
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await axiosInstance(config);
    } catch (err) {
      if (i === maxRetries - 1) throw err;
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }
};

  const extractArrayFromResponse = (data, apiName) => {
    let arrayData = [];
    if (Array.isArray(data)) {
      arrayData = data;
    } else if (data && typeof data === "object") {
      const possibleKeys = [
        "data", "categories", "suppliers", "medicines",
        "purchases", "records", "doses", "items",
      ];
      for (const key of possibleKeys) {
        if (Array.isArray(data[key])) {
          arrayData = data[key];
          break;
        }
      }
    }
    let isValid = false;
    if (apiName === "Category API") {
      isValid = arrayData.every((item) => item?.id && item?.name);
    } else if (apiName === "Supplier API") {
      isValid = arrayData.every((item) => item?.id && item?.supplierName);
    } else if (apiName === "Medicine API") {
      isValid = arrayData.every(
        (item) => item?.id && item?.medicineName && item?.medicineCategory
      );
    } else if (apiName === "Purchase API") {
      isValid = arrayData.every((item) => item?.id);
    } else if (apiName === "Group API") {
      isValid = arrayData.every((item) => item?.id && item?.groupName);
    } else if (apiName === "Company API") {
      isValid = arrayData.every((item) => item?.id && item?.companyName);
    } else if (apiName === "Unit API") {
      isValid = arrayData.every((item) => item?.id && item?.name);
    }
    return isValid ? arrayData : [];
  };
useEffect(() => {
    const fetchAuthorities = async () => {
        try {
            const res = await retryRequest({
                method: "get",
                url: AUTHORITIES_API_URL,
                headers: { "x-api-key": API_KEY },
            });
            const authorityList = Array.isArray(res.data) ? res.data : [];
            const options = authorityList.map((auth) => ({
                value: auth.name,
                label: auth.name,
            }));
            setAuthorizedByOptions(options);
        } catch (err) {
            console.error("Error fetching authorities:", err);
            toast.error("Failed to load authorizers.");
        }
    };

    if (isOpen) {
        fetchAuthorities();
    }
  }, [isOpen]);
  const getFilteredMedicines = useCallback((categoryId) => {
    if (!categoryId || !categories.options) return [];
    const selectedCategory = categories.options.find((cat) => cat.value === categoryId);
    if (!selectedCategory) return [];
    return rawMedicines
      .filter((medicine) => medicine.medicineCategory === selectedCategory.label)
      .map((item) => ({
        value: item.id.toString(),
        label: item.medicineName,
      }));
  }, [categories.options, rawMedicines]);

  const handleCreateCategory = async (inputValue) => {
    if (!inputValue.trim()) {
      toast.error("Category name cannot be empty");
      return;
    }
    try {
      const response = await axios.post(
        `${MEDICINE_CATEGORY_API}/add`,
        { name: inputValue.trim() },
        {
          headers: {
            "X-Api-Key": API_KEY,
            "Content-Type": "application/json",
          },
        }
      );
      const newCategory = response.data.category;
      if (!newCategory?.id || !newCategory?.name) {
        throw new Error("Invalid category data returned from server");
      }
      const newOption = {
        value: newCategory.id.toString(),
        label: newCategory.name,
      };
      setCategories((prev) => ({
        options: [...prev.options, newOption],
      }));
      setFormData((prev) =>
        prev.map((row, idx) =>
          idx === prev.length - 1
            ? {
              ...row,
              medicineCategory: newOption.value,
              medicineName: "",
              unitPerBox: 0,
              quantity: 0,
              price: 0,
            }
            : row
        )
      );
      toast.success(`Category "${newCategory.name}" added successfully!`);
    } catch (error) {
      console.error("Create Category Error:", error);
      let errorMessage = "Failed to add category";
      if (error.response) {
        if (error.response.status === 400) {
          errorMessage = error.response.data.error || "Invalid category name";
        } else if (error.response.status === 401) {
          errorMessage = "Unauthorized: Invalid API key";
        } else {
          errorMessage = error.response.data.error || "Server error occurred";
        }
      } else {
        errorMessage = error.message || "Network error occurred";
      }
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

const resetFormState = useCallback(() => {
  setFormData([
    {
      medicineCategory: "",
      medicineName: "",
      batchNo: "",
      expiryDate: "",
      boxQty: null,
      unitPerBox: null,
      quantity: null,
      supplierPrice: null,
      boxPrice: null,
      amount: null,
      price: null,
    },
  ]);
  setSupplierId("");
  setBillNo("");
  setPurchaseDate(format(new Date(), "yyyy-MM-dd"));
  setDiscount(0);
  setTax(0);
  setAuthorizedBy("");
  setPaymentMode("cash");
  setPaymentAmount(0);
  setHasEditedPaymentAmount(false);
  setNetAmount(0);
  setReturnAmount(0);
  setDueAmount(0);
  setPaymentNotes("");
  setImage(null);
  setExistingDocumentUrl("");
  setAddMedicineModalOpen(false);
  setUserName(user?.name || "Unknown User");
  setUserPhone(user?.mobile || "Unknown Mobile");
}, [user]);

  useEffect(() => {
    if (isOpen && !purchaseId) {
      resetFormState();
    }
  }, [isOpen, purchaseId, resetFormState]);

  useEffect(() => {
    const fetchStaticData = async () => {
      setIsLoading(true);
      const headers = { "X-Api-Key": API_KEY };
      try {
        let allMedicines = [];
        let currentPage = 1;
        const limit = 10000;
        let hasMore = true;

        while (hasMore) {
          const medicineResponse = await axios.get(MEDICINE_API, {
            headers,
            params: { page: currentPage, limit },
          });
          const medicines = extractArrayFromResponse(medicineResponse.data, "Medicine API");
          allMedicines = [...allMedicines, ...medicines];
          const { pagination } = medicineResponse.data;
          hasMore = currentPage < (pagination?.totalPages || 1);
          currentPage++;
        }

        const [
          categoryResponse, supplierResponse, groupResponse, companyResponse, unitResponse,
        ] = await Promise.all([
          axios.get(MEDICINE_CATEGORY_API, { headers }),
          axios.get(SUPPLIER_API, { headers }),
          axios.get(MEDICINE_GROUP_API, { headers }),
          axios.get(MEDICINE_COMPANY_API, { headers }),
          axios.get(MEDICINE_UNIT_API, { headers }),
        ]);

        setCategories({
          options: extractArrayFromResponse(categoryResponse.data, "Category API").map((item) => ({
            value: item.id.toString(), label: item.name,
          })) || [{ value: "fallback_category", label: "Default Category" }],
        });

        setSuppliers(
          extractArrayFromResponse(supplierResponse.data, "Supplier API").map((item) => ({
            value: item.id.toString(), label: item.supplierName,
          })) || [{ value: "fallback_supplier", label: "Default Supplier" }]
        );

        setRawMedicines(allMedicines);
        setGroups(Array.isArray(groupResponse.data.doses) ? groupResponse.data.doses : Array.isArray(groupResponse.data.items) ? groupResponse.data.items : Array.isArray(groupResponse.data) ? groupResponse.data : []);
        setCompanies(Array.isArray(companyResponse.data.categories) ? companyResponse.data.categories : Array.isArray(companyResponse.data) ? companyResponse.data : []);
        setUnits(Array.isArray(unitResponse.data.categories) ? unitResponse.data.categories : Array.isArray(unitResponse.data) ? unitResponse.data : []);
      } catch (error) {
        console.error("Static Data Fetch Error:", error);
        toast.error(`Failed to fetch static data: ${error.response?.data?.error || error.message}`);
      } finally {
        setIsLoading(false);
      }
    };
    if (isOpen) {
      fetchStaticData();
    }
  }, [isOpen]);

  useEffect(() => {
  const fetchPurchaseData = async () => {
    if (!purchaseId || !categories.options.length || !rawMedicines.length) return;
    setIsLoading(true);
    const headers = { "X-Api-Key": API_KEY };
    try {
      const response = await axios.get(`${API_BASE}/${purchaseId}`, { headers });
      const purchase = response.data.purchase;

      if (!purchase?.items) {
        toast.error("Invalid purchase data");
        return;
      }

      let parsedItems = [];
      try {
        if (typeof purchase.items === 'string') {
          parsedItems = JSON.parse(purchase.items);
        } else if (Array.isArray(purchase.items)) {
          parsedItems = purchase.items;
        }
      } catch (err) {
        console.error("Error parsing items:", err);
        parsedItems = [];
      }

      setFormData(
        parsedItems.map((item) => ({
          medicineCategory: categories.options.find((cat) => cat.label === item.medicineCategory)?.value || "",
          medicineName: item.medicineId.toString(),
          batchNo: item.batchNo || "",
          expiryDate: item.expiryDate ? format(new Date(item.expiryDate), "yyyy-MM-dd") : "",
          boxQty: Math.round(parseFloat(item.boxQty) || 0),
          unitPerBox: Math.round(parseFloat(item.unitPerBox || item.perUnitQty) || 0),
          quantity: Math.round(parseInt(item.quantity) || 0),

          supplierPrice: Math.round(parseFloat(item.supplierPrice) || 0),
          boxPrice: Math.round(parseFloat(item.boxPrice) || 0),
          amount: Math.round(parseFloat(item.amount) || 0),
          price: Math.round(parseFloat(item.price) || (item.boxPrice && item.unitPerBox > 0 ? item.boxPrice / item.unitPerBox : 0)),
        }))
      );
      setSupplierId(purchase.supplierId?.toString() || "");
      setBillNo(purchase.billNo || "");
      setPurchaseDate(purchase.purchaseDate ? format(new Date(purchase.purchaseDate), "yyyy-MM-dd") : format(new Date(), "yyyy-MM-dd"));
      setDiscount(Math.round(parseFloat(purchase.discount) || 0));
      setTax(Math.round(parseFloat(purchase.items[0]?.tax) || 0));
      setPaymentMode(purchase.paymentMode || "cash");
      setPaymentAmount(Math.round(parseFloat(purchase.paymentAmount) || 0));
      setHasEditedPaymentAmount(!!purchase.paymentAmount);
      setNetAmount(Math.round(parseFloat(purchase.netAmount) || 0));
      setTotalAmount(Math.round(parseFloat(purchase.totalAmount) || 0));
      setPaymentNotes(purchase.paymentNote || "");
      setExistingDocumentUrl(purchase.documentUrl || "");
      setUserName(purchase.userName || "Unknown User");
      setUserPhone(purchase.userPhone || "Unknown Mobile");
      setAuthorizedBy(purchase.authorizedBy || "");

      const payment = Math.round(parseFloat(purchase.paymentAmount) || 0);
      const net = Math.round(parseFloat(purchase.netAmount) || 0);
      setReturnAmount(payment > net && payment ? Math.round(payment - net) : 0);
      setDueAmount(payment < net && payment ? Math.round(net - payment) : 0); 
    } catch (error) {
      console.error("Purchase Data Fetch Error:", error);
      toast.error(`Failed to fetch purchase data: ${error.response?.data?.error || error.message}`);
    } finally {
      setIsLoading(false);
    }
  };
  if (isOpen && purchaseId && categories.options.length && rawMedicines.length) {
    fetchPurchaseData();
  }
}, [isOpen, purchaseId, categories.options, rawMedicines]);

  const calculatedFormData = useMemo(() => {
  return formData.map((row) => {
    const boxQty = parseFloat(row.boxQty) || 0;
    const supplierPrice = parseFloat(row.supplierPrice) || 0;
    const boxPrice = parseFloat(row.boxPrice) || 0;
    const unitPerBox = parseFloat(row.unitPerBox) || 0;
    const price = unitPerBox > 0 ? Math.round(boxPrice / unitPerBox) : 0; 
    const amount = Math.round(boxQty * supplierPrice);
    return { ...row, price, amount };
  });
}, [formData]);

  useEffect(() => {
  const total = Math.round(
    calculatedFormData.reduce((sum, row) => sum + (row.amount || 0), 0)
  );
  const discountAmt = Math.round(parseFloat(discount) || 0); 
  const taxableAmount = total - discountAmt;
  const taxAmount = Math.round(taxableAmount * (parseFloat(tax) / 100 || 0));
  const finalAmount = Math.round(taxableAmount + taxAmount);
  setTotalAmount(finalAmount); 
  setNetAmount(finalAmount);

  if (!hasEditedPaymentAmount) {
    setPaymentAmount(finalAmount);
  }
  const payment = Math.round(parseFloat(paymentAmount) || finalAmount);
  setReturnAmount(payment > finalAmount && payment ? Math.round(payment - finalAmount) : 0);
  setDueAmount(payment < finalAmount && payment ? Math.round(finalAmount - payment) : 0);
}, [calculatedFormData, discount, tax, paymentAmount, hasEditedPaymentAmount]);

  useEffect(() => {
    return () => {
      if (image) {
        URL.revokeObjectURL(URL.createObjectURL(image));
      }
    };
  }, [image]);

  const handleSelectChange = (index, name) => (selectedOption) => {
    const newFormData = [...formData];
    newFormData[index][name] = selectedOption ? selectedOption.value : "";
    if (name === "medicineCategory") {
      newFormData[index].medicineName = "";
      newFormData[index].unitPerBox = 0;
      newFormData[index].quantity = 0;
      newFormData[index].price = 0;
    }
    if (name === "medicineName") {
      newFormData[index].unitPerBox = 0;
      newFormData[index].quantity = 0;
      newFormData[index].price = 0;
    }
    setFormData(newFormData);
  };

  const handleInputChange = (index, e) => {
  const { name, value } = e.target;
  const newFormData = [...formData];
  if (["batchNo", "expiryDate"].includes(name)) {
    newFormData[index][name] = value;
    if (name === "batchNo") {
      newFormData[index].unitPerBox = 0;
      newFormData[index].quantity = 0;
      newFormData[index].price = 0;
    }
  } else {
    const parsedValue = parseFloat(value);
    newFormData[index][name] = isNaN(parsedValue) || parsedValue < 0 ? 0 : Math.round(parsedValue);
  }
  if (name === "quantity" || name === "boxQty" || name === "unitPerBox") {
    const quantity = parseFloat(newFormData[index].quantity) || 0;
    const boxQty = parseFloat(newFormData[index].boxQty) || 0;
    const unitPerBox = parseFloat(newFormData[index].unitPerBox) || 0;
    if (name === "quantity" && boxQty > 0 && unitPerBox > 0) {
      newFormData[index].unitPerBox = Math.round(quantity / boxQty) || 0;
    } else if (name === "boxQty" || name === "unitPerBox") {
      newFormData[index].quantity = Math.round(unitPerBox * boxQty) || 0;
    }
  }
  const boxQty = parseFloat(newFormData[index].boxQty) || 0;
  const supplierPrice = parseFloat(newFormData[index].supplierPrice) || 0;
  const boxPrice = parseFloat(newFormData[index].boxPrice) || 0;
  const unitPerBox = parseFloat(newFormData[index].unitPerBox) || 0;
  const price = unitPerBox > 0 ? Math.round(boxPrice / unitPerBox) : 0;
  const amount = Math.round(boxQty * supplierPrice);
  newFormData[index].price = price;
  newFormData[index].amount = amount;
  setFormData(newFormData);
};

  const handleOtherInputChange = (setter) => (e) => {
  const value =
    setter === setBillNo || setter === setPaymentNotes || setter === setPurchaseDate
      ? e.target.value
      : Math.round(parseFloat(e.target.value) || 0);
  setter(value);
  if (setter === setPaymentAmount) {
    setHasEditedPaymentAmount(true);
  }
};

  const handleImageChange = (setter) => (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png"];
      const maxSize = 1 * 1024 * 1024;
      if (!validTypes.includes(file.type)) {
        toast.error("Only JPEG or PNG files are allowed");
        return;
      }
      if (file.size > maxSize) {
        toast.error("File size exceeds 1MB limit");
        return;
      }
      setImage(file);
    }
  };

  const handleSupplierChange = (selectedOption) => {
    setSupplierId(selectedOption ? selectedOption.value : "");
  };

  const handlePaymentModeChange = (selectedOption) => {
    setPaymentMode(selectedOption ? selectedOption.value : "");
  };

  // addNewRow থেকে userName এবং userPhone সরানো হয়েছে
  const addNewRow = () => {
    setFormData([
      ...formData,
      {
        medicineCategory: "",
        medicineName: "",
        batchNo: "",
        expiryDate: "",
        boxQty: 0,
        unitPerBox: 0,
        quantity: 0,
        supplierPrice: 0,
        boxPrice: 0,
        amount: 0,
        price: 0,
      },
    ]);
  };

  const removeRow = (index) => {
    if (formData.length === 1) {
      toast.error("At least one medicine is required");
      return;
    }
    setFormData(formData.filter((_, i) => i !== index));
  };

  const handleAddMedicine = async (newMedicine) => {
    if (!newMedicine || !newMedicine.id) {
      toast.error("Failed to add medicine: Invalid data");
      return;
    }
    setAddMedicineModalOpen(false);
    try {
      let allMedicines = [];
      let currentPage = 1;
      const limit = 10000;
      let hasMore = true;

      while (hasMore) {
        const response = await axios.get(MEDICINE_API, {
          headers: { "X-Api-Key": API_KEY },
          params: { page: currentPage, limit },
        });
        const medicines = extractArrayFromResponse(response.data, "Medicine API");
        allMedicines = [...allMedicines, ...medicines];
        const { pagination } = response.data;
        hasMore = currentPage < (pagination?.totalPages || 1);
        currentPage++;
      }
      setRawMedicines(allMedicines);
      toast.success("Medicine added successfully!");
    } catch (error) {
      console.error("Refresh Medicines Error:", error);
      toast.error("Failed to refresh medicines list");
    }
  };

  const validateForm = () => {
    if (!supplierId || !purchaseDate || !paymentMode || !authorizedBy || paymentAmount <= 0) {
  toast.error("Please fill all required fields: Supplier, Date, Payment Mode, Authorizer, and Payment Amount");
  return false;
}

    if (tax < 0) {
      toast.error("Tax cannot be negative");
      return false;
    }

    for (const [index, row] of formData.entries()) {
      if (
        !row.medicineCategory || !row.medicineName || !row.batchNo || !row.expiryDate ||
        row.boxQty <= 0 || row.unitPerBox <= 0 || row.quantity <= 0 ||
        row.supplierPrice <= 0 || row.boxPrice <= 0 || row.amount <= 0
      ) {
        toast.error(`Please fill all required fields for medicine ${index + 1}`);
        return false;
      }

      if (!categories.options.find((cat) => cat.value === row.medicineCategory)) {
        toast.error(`Invalid medicine category for medicine ${index + 1}`);
        return false;
      }

      if (!rawMedicines.find((med) => med.id.toString() === row.medicineName)) {
        toast.error(`Invalid medicine for medicine ${index + 1}`);
        return false;
      }

      if (new Date(row.expiryDate).toString() === "Invalid Date" || new Date(purchaseDate).toString() === "Invalid Date") {
        toast.error(`Invalid dates for medicine ${index + 1}`);
        return false;
      }

      const calculatedQuantity = parseInt(row.unitPerBox * row.boxQty) || 0;
      if (calculatedQuantity !== parseInt(row.quantity)) {
        toast.error(`Quantity does not match Units per Box * Box Qty for medicine ${index + 1}`);
        return false;
      }
    }
    return true;
  };
const handleAuthorizedByChange = (e) => {
  setAuthorizedBy(e.target.value);
};
  const handleSubmit = async () => {
  if (!validateForm()) return;
  setIsLoading(true);

  try {
    const formTax = Math.round(parseFloat(tax) || 0); 
    const items = formData.map((row) => {
      const category = categories.options.find((cat) => cat.value === row.medicineCategory);
      const medicineData = rawMedicines.find((med) => med.id.toString() === row.medicineName);
      if (!category || !medicineData) {
        throw new Error(`Invalid category or medicine: ${medicineData?.medicineName || "unknown"}`);
      }
      const itemAmount = Math.round(parseFloat(row.boxQty) * parseFloat(row.supplierPrice)); 
      const itemTaxAmount = Math.round(itemAmount * (formTax / 100)); 
      return {
        medicineId: parseInt(medicineData.id),
        medicineName: medicineData.medicineName,
        medicineCategory: category.label,
        batchNo: row.batchNo,
        expiryDate: row.expiryDate,
        boxQty: Math.round(parseFloat(row.boxQty)), 
        unitPerBox: Math.round(parseFloat(row.unitPerBox)), 
        quantity: Math.round(parseInt(row.quantity)), 
        supplierPrice: Math.round(parseFloat(row.supplierPrice)), 
        boxPrice: Math.round(parseFloat(row.boxPrice)), 
        tax: formTax,
        taxAmount: itemTaxAmount,
        amount: itemAmount,
        price: Math.round(parseFloat(row.price)), 
      };
    });

    const formPayload = new FormData();
    formPayload.append("billNo", billNo);
    formPayload.append("purchaseDate", purchaseDate);
    formPayload.append("supplierId", parseInt(supplierId));
    formPayload.append("discount", Math.round(parseFloat(discount))); 
    formPayload.append("netAmount", Math.round(parseFloat(netAmount))); 
    formPayload.append("totalAmount", Math.round(parseFloat(totalAmount))); 
    formPayload.append("paymentMode", paymentMode);
    formPayload.append("paymentAmount", Math.round(parseFloat(paymentAmount))); 
    if (returnAmount) formPayload.append("returnAmount", Math.round(parseFloat(returnAmount))); 
    if (dueAmount) formPayload.append("dueAmount", Math.round(parseFloat(dueAmount))); 
    if (paymentNotes) formPayload.append("paymentNote", paymentNotes);
      formPayload.append("authorizedBy", authorizedBy);
    formPayload.append("userName", userName);
    formPayload.append("userPhone", userPhone);
    formPayload.append("items", JSON.stringify(items));
    if (image) {
      formPayload.append("document", image);
    }

    const url = purchaseId ? `${API_BASE}/${purchaseId}` : `${API_BASE}/add`;
    const method = purchaseId ? "PUT" : "POST";

    const response = await axios({
      method,
      url,
      data: formPayload,
      headers: { "X-Api-Key": API_KEY },
    });

    toast.success(`Purchase ${purchaseId ? "updated" : "saved"} successfully!`);
    onSave();
    onClose();
  } catch (error) {
    console.error("Save Purchase Error:", error);
    const errorMessage =
      error.response?.status === 400
        ? error.response.data.error
        : error.response?.status === 500
          ? "Server error: Unable to process request. Please ensure file is a valid JPEG/PNG under 1MB and try again."
          : error.response?.data?.error || error.message;
    toast.error(`Error saving purchase: ${errorMessage}`);
  } finally {
    setIsLoading(false);
  }
};

  const handleClose = () => {
    resetFormState();
    setCategories({ options: [] });
    setRawMedicines([]);
    setGroups([]);
    setCompanies([]);
    setUnits([]);
    onClose();
  };

  if (!isOpen) return null;

  if (isLoading || !categories.options || !rawMedicines) {
    return (
      <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-40">
        <div className="bg-white shadow-lg p-6 w-full max-w-full max-h-[100vh] h-full overflow-y-auto">
          <div className="bg-[#ececec] p-5 rounded-lg flex justify-between items-center mb-4">
            <Skeleton height={24} width={200} baseColor="#e2e8f0" highlightColor="#f7fafc" />
            <Skeleton height={20} width={20} baseColor="#e2e8f0" highlightColor="#f7fafc" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
            {[...Array(3)].map((_, idx) => (
              <Skeleton key={idx} height={40} baseColor="#e2e8f0" highlightColor="#f7fafc" />
            ))}
          </div>
          <div className="mt-6 flex gap-3 justify-end items-center">
            <Skeleton height={40} width={150} baseColor="#e2e8f0" highlightColor="#f7fafc" />
          </div>
          <div className="border-b border-dashed pb-4 mb-4 min-w-[1200px] w-full">
            <div className="grid grid-cols-10 gap-4">
              {[...Array(10)].map((_, idx) => (
                <Skeleton key={idx} height={20} width={100} baseColor="#e2e8f0" highlightColor="#f7fafc" />
              ))}
            </div>
            {[...Array(2)].map((_, rowIdx) => (
              <div key={rowIdx} className="grid grid-cols-10 gap-4 mb-4">
                {[...Array(10)].map((_, idx) => (
                  <Skeleton key={idx} height={40} baseColor="#e2e8f0" highlightColor="#f7fafc" />
                ))}
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 mt-8">
            <div>
              <Skeleton height={80} className="mb-4" baseColor="#e2e8f0" highlightColor="#f7fafc" />
              <Skeleton height={40} baseColor="#e2e8f0" highlightColor="#f7fafc" />
            </div>
            <div className="border p-3 rounded-md">
              <div className="grid grid-cols-3 gap-4 mb-4">
                {[...Array(6)].map((_, idx) => (
                  <Skeleton key={idx} height={40} baseColor="#e2e8f0" highlightColor="#f7fafc" />
                ))}
              </div>
              <div className="flex justify-end gap-2 mt-5">
                <Skeleton height={40} width={120} baseColor="#e2e8f0" highlightColor="#f7fafc" />
                <Skeleton height={40} width={120} baseColor="#e2e8f0" highlightColor="#f7fafc" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full min-h-[calc(100vh-50px)] h-full overflow-y-auto">
        {/* Modal Header */}
        <div className="flex flex-wrap gap-3 flex-row md:items-center justify-between bg-gray-200 border-b border-dashed border-M-text-color/50 p-4 print-hidden px-6">
          <h2 className="text-lg font-medium text-black flex items-center gap-2">
            {purchaseId ? "Edit Purchase" : "Add New Purchase"}
          </h2>
          <button
            onClick={handleClose}
            disabled={isLoading}
            title="Close"
            className="size-7 ml-auto rounded-full bg-white text-M-secondary-color text-sm flex items-center justify-center hover:bg-M-secondary-color hover:text-white transition-all duration-300"
          >
            <RiCloseLargeFill />
          </button>
        </div>
        {/* Modal Body */}
        <div className="p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <label htmlFor="invoice-number" className="label font-medium text-black">
                Invoice Number: <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                value={billNo}
                onChange={handleOtherInputChange(setBillNo)}
                placeholder="Invoice Number"
                disabled={isLoading || purchaseId}
                className="input-field"
              />
            </div>
            <div>
          <label className="label">Authorized By <span className="text-red-500">*</span></label>
          <DynamicSelect
            options={authorizedByOptions}
            value={authorizedByOptions.find((option) => option.value === authorizedBy) || null}
            onChange={(selectedOption) => setAuthorizedBy(selectedOption ? selectedOption.value : "")}
            isSearchable
            placeholder="Select Authorizer"
            controlBackgroundColor="transparent"
            controlFontSize="13px"
            isDisabled={isLoading}
            className={`w-full ${!authorizedBy ? "border-red-500" : ""}`}
          />
          
        </div>
            <div className="md:col-start-3">
              <label htmlFor="purchase-date" className="label font-medium text-black">
                Date: <span className="text-red-600">*</span>
              </label>
              <input
                type="date"
                value={purchaseDate}
                onChange={handleOtherInputChange(setPurchaseDate)}
                className="input-field"
                disabled={isLoading}
              />
            </div>
            <div>
              <label htmlFor="supplier-name" className="label font-medium text-black">
                Supplier Name: <span className="text-red-600">*</span>
              </label>
              <DynamicSelect
                options={suppliers}
                value={suppliers.find((option) => option.value === supplierId) || null}
                onChange={handleSupplierChange}
                isSearchable
                placeholder="Select Supplier"
                controlBackgroundColor="transparent"
                controlFontSize="13px"
                isDisabled={isLoading}
              />
            </div>
            <div>
              <label htmlFor="payment-mode" className="label font-medium text-black">
                Payment Mode: <span className="text-red-600">*</span>
              </label>
              <DynamicSelect
                options={paymentModes}
                value={paymentModes.find((option) => option.value === paymentMode) || null}
                onChange={handlePaymentModeChange}
                isSearchable
                placeholder="Select Payment Mode"
                controlBackgroundColor="transparent"
                controlFontSize="13px"
                isDisabled={isLoading}
              />
            </div>
            <div>
              <label htmlFor="attach-document" className="label font-medium text-black">
                Attach Document:
              </label>
              <input
                type="file"
                accept="image/jpeg,image/png"
                onChange={handleImageChange(setImage)}
                className="mt-1 block w-full text-sm text-gray-600 border border-gray-200 rounded-md p-[1px] file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200"
                disabled={isLoading}
              />
              {existingDocumentUrl && (
                <div className="mt-2">
                  <p className="text-sm text-gray-600">
                    Current Document:{" "}
                    <a
                      href={`https://api.muktihospital.com${existingDocumentUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline"
                    >
                      View
                    </a>
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="mt-6 flex gap-3 justify-end items-center">
            <button
              onClick={() => setAddMedicineModalOpen(true)}
              className="bg-[#73CB64] hover:bg-M-primary-color default-button shrink-0"
              aria-label="Add New Medicine"
              disabled={isLoading}
            >
              <RiAddLargeFill className="inline mr-2" /> Add New Medicine
            </button>
          </div>

          <div className="overflow-x-auto mt-6">
            <table className="w-full table-fixed border-collapse min-w-[1400px]">
              <thead className="bg-gray-100">
                <tr>
                  <th className="text-left text-sm text-black border border-gray-300 py-2 px-3 font-medium">
                    Category <span className="text-red-600">*</span>
                  </th>
                  <th className="text-left text-sm text-black border border-gray-300 py-2 px-3 font-medium">
                    Name <span className="text-red-600">*</span>
                  </th>
                  <th className="text-left text-sm text-black border border-gray-300 py-2 px-3 font-medium">
                    Batch ID <span className="text-red-600">*</span>
                  </th>
                  <th className="text-left text-sm text-black border border-gray-300 py-2 px-3 font-medium">
                    Expiry Date <span className="text-red-600">*</span>
                  </th>
                  <th className="text-left text-sm text-black border border-gray-300 py-2 px-3 font-medium">
                    Units per Box <span className="text-red-600">*</span>
                  </th>
                  <th className="text-left text-sm text-black border border-gray-300 py-2 px-3 font-medium">
                    Box Qty <span className="text-red-600">*</span>
                  </th>
                  <th className="text-left text-sm text-black border border-gray-300 py-2 px-3 font-medium">
                    Quantity <span className="text-red-600">*</span>
                  </th>
                  <th className="text-left text-sm text-black border border-gray-300 py-2 px-3 font-medium">
                    Supplier Box Price <span className="text-red-600">*</span>
                  </th>
                  <th className="text-left text-sm text-black border border-gray-300 py-2 px-3 font-medium">
                    Box MRP <span className="text-red-600">*</span>
                  </th>
                  <th className="text-left text-sm text-black border border-gray-300 py-2 px-3 font-medium">
                    Total
                  </th>
                  <th className="text-center text-sm text-black border border-gray-300 py-2 px-3 w-16 font-medium">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {formData.map((row, index) => (
                  <tr key={index}>
                    <td className="border border-gray-200 py-2 px-3">
                      <CreatableSelect
                        options={categories.options}
                        value={categories.options.find((option) => option.value === row.medicineCategory) || null}
                        onChange={handleSelectChange(index, "medicineCategory")}
                        onCreateOption={handleCreateCategory}
                        isSearchable={true}
                        placeholder="Search or Add"
                        isDisabled={isLoading}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            borderColor: '#cbd5e0',
                            fontSize: '13px',
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                            '&:hover': {
                              borderColor: '#a0aec0',
                            },
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            fontSize: '13px',
                            height: '40px',
                            backgroundColor: state.isSelected
                              ? '#3b82f6'
                              : state.isFocused
                                ? '#ebf8ff'
                                : 'transparent',
                            color: state.isSelected ? '#ffffff' : '#2d3748',
                          }),
                          menu: (provided) => ({
                            ...provided,
                            backgroundColor: '#ffffff',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            padding: '0px',
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: '#2d3748',
                          }),
                          input: (provided) => ({
                            ...provided,
                            color: '#2d3748',
                          }),
                        }}
                      />
                    </td>
                    <td className="border border-gray-200 py-2 px-3">
                      <DynamicSelect
                        options={getFilteredMedicines(row.medicineCategory)}
                        value={getFilteredMedicines(row.medicineCategory).find((option) => option.value === row.medicineName) || null}
                        onChange={handleSelectChange(index, "medicineName")}
                        isSearchable
                        placeholder="Select"
                        controlBackgroundColor="transparent"
                        controlFontSize="13px"
                        isDisabled={isLoading || !row.medicineCategory}
                      />
                    </td>
                    <td className="border border-gray-200 py-2 px-3">
                      <input
                        type="text"
                        name="batchNo"
                        value={row.batchNo}
                        onChange={(e) => handleInputChange(index, e)}
                        className="input-field"
                        placeholder="Batch ID"
                        disabled={isLoading}
                      />
                    </td>
                    <td className="border border-gray-200 py-2 px-3">
                      <input
                        type="date"
                        name="expiryDate"
                        value={row.expiryDate}
                        onChange={(e) => handleInputChange(index, e)}
                        className="input-field"
                        placeholder="Expiry Date"
                        disabled={isLoading}
                      />
                    </td>
                    <td className="border border-gray-200 py-2 px-3">
                      <input
                        type="number"
                        name="unitPerBox"
                        value={row.unitPerBox || ""}
                        onChange={(e) => handleInputChange(index, e)}
                        className="input-field text-end"
                        placeholder="0"
                        min="0"
                        step="1" 
                        disabled={isLoading}
                      />
                    </td>
                    <td className="border border-gray-200 py-2 px-3">
                      <input
                        type="number"
                        name="boxQty"
                        value={row.boxQty || ""}
                        onChange={(e) => handleInputChange(index, e)}
                        className="input-field text-end"
                        placeholder="0"
                        min="0"
                        step="1" 
                        disabled={isLoading}
                      />
                    </td>
                    <td className="border border-gray-200 py-2 px-3">
                      <input
                        type="number"
                        name="quantity"
                        value={row.quantity || ""}
                        onChange={(e) => handleInputChange(index, e)}
                        className="input-field text-end"
                        placeholder="0"
                        min="0"
                        step="1"
                        disabled={isLoading}
                      />
                    </td>
                    <td className="border border-gray-200 py-2 px-3">
                      <input
                        type="number"
                        name="supplierPrice"
                        value={row.supplierPrice || ""}
                        onChange={(e) => handleInputChange(index, e)}
                        className="input-field text-end"
                        placeholder="0"
                        min="0"
                        step="1"
                        disabled={isLoading}
                      />
                    </td>
                    <td className="border border-gray-200 py-2 px-3">
                      <input
                        type="number"
                        name="boxPrice"
                        value={row.boxPrice || ""}
                        onChange={(e) => handleInputChange(index, e)}
                        className="input-field text-end"
                        placeholder="0"
                        min="0"
                        step="1" 
                        disabled={isLoading}
                      />
                    </td>
                    <td className="border border-gray-200 py-2 px-3">
                      <input
                        type="number"
                        value={Math.round(row.amount || 0)}
                        className="input-field text-end disabled:bg-gray-100"
                        disabled
                        placeholder="0"
                      />
                    </td>
                    <td className="border border-gray-200 py-2 px-3">
                      <button
                        title="Remove"
                        onClick={() => removeRow(index)}
                        className="size-7 mx-auto rounded-full bg-M-secondary-color/10 text-M-secondary-color text-sm flex items-center justify-center hover:bg-M-secondary-color hover:text-white transition-all duration-300"
                        disabled={isLoading}
                      >
                        <RiDeleteBin6Line />
                      </button>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td
                    className="text-right text-sm text-black border border-gray-300 py-2 px-3 font-medium"
                    colSpan={9}
                  >
                    Sub Total
                  </td>
                  <td className="border border-gray-200 py-2 px-3">
                    <input
                      type="number"
                      value={Math.round(
                        calculatedFormData.reduce((sum, row) => sum + (row.amount || 0), 0)
                      )} 
                      className="input-field text-end disabled:bg-gray-100"
                      disabled
                      placeholder="0"
                    />
                  </td>
                  <td className="border border-gray-200 py-2 px-3">
                    <button
                      onClick={addNewRow}
                      title="Add"
                      className="size-7 mx-auto rounded-full bg-M-Green-color/10 text-M-Green-color text-sm flex items-center justify-center hover:bg-M-Green-color hover:text-white transition-all duration-300"
                    >
                      <RiAddLargeFill />
                    </button>
                  </td>
                </tr>
                <tr>
                    <td
                      className="text-right text-sm text-black border border-gray-300 py-2 px-3 font-medium"
                      colSpan={9}
                    >
                      Vat (%)
                    </td>
                    <td className="border border-gray-200 py-2 px-3" colSpan={2}>
                      <input
                        type="number"
                        value={tax}
                        onChange={handleOtherInputChange(setTax)}
                        className="input-field text-end"
                        placeholder="0"
                        min="0"
                        step="1" 
                        disabled={isLoading}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="text-right text-sm text-black border border-gray-300 py-2 px-3 font-medium"
                      colSpan={9}
                    >
                      Discount (TK)
                    </td>
                    <td className="border border-gray-200 py-2 px-3" colSpan={2}>
                      <input
                        type="number"
                        value={discount}
                        onChange={handleOtherInputChange(setDiscount)}
                        readOnly={!!purchaseId}
                        className={`w-full p-2 border rounded-md text-sm text-end focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                            errors.discount ? "border-red-500" : "border-gray-300"
                          }
                          ${purchaseId ? "bg-gray-100 cursor-not-allowed" : ""} 
                          `}
                        placeholder="0"
                        min="0"
                        step="1"
                        disabled={isLoading}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="text-right text-sm text-black border border-gray-300 py-2 px-3 font-medium"
                      colSpan={9}
                    >
                      Grand Total (TK)
                    </td>
                    <td className="border border-gray-200 py-2 px-3" colSpan={2}>
                      <input
                        type="number"
                        value={netAmount}
                        className="input-field text-end disabled:bg-gray-100"
                        disabled
                        placeholder="0" 
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="text-right text-sm text-black border border-gray-300 py-2 px-3 font-medium"
                      colSpan={9}
                    >
                      Paid Amount (TK)
                    </td>
                    <td className="border border-gray-200 py-2 px-3" colSpan={2}>
                      <input
                        type="number"
                        value={paymentAmount}
                        onChange={handleOtherInputChange(setPaymentAmount)}
                        readOnly={!!purchaseId}
                        className={`w-full p-2 border rounded-md text-sm text-end focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                          errors.paymentAmount ? "border-red-500" : "border-gray-300"
                        }
                        ${purchaseId ? "bg-gray-100 cursor-not-allowed" : ""}
                        `}
                        placeholder="0"
                        min="0"
                        step="1"
                        disabled={isLoading}
                      />
                    </td>
                  </tr>
                  {dueAmount >= 0 && (
                    <tr>
                      <td
                        className="text-right text-sm text-black border border-gray-300 py-2 px-3 font-medium"
                        colSpan={9}
                      >
                        Due Amount (TK)
                      </td>
                      <td className="border border-gray-200 py-2 px-3" colSpan={2}>
                        <input
                          type="number"
                          value={dueAmount} 
                          className="input-field text-end disabled:bg-gray-100"
                          disabled
                          placeholder="0"
                        />
                      </td>
                    </tr>
                  )}
                  {returnAmount > 0 && (
                    <tr>
                      <td
                        className="text-right text-sm text-black border border-gray-300 py-2 px-3 font-medium"
                        colSpan={9}
                      >
                        Return Amount (TK)
                      </td>
                      <td className="border border-gray-200 py-2 px-3" colSpan={2}>
                        <input
                          type="number"
                          value={returnAmount}
                          className="input-field text-end disabled:bg-gray-100"
                          disabled
                          placeholder="0"
                        />
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
          <div className="mt-4 pt-4 max-w-[700px]">
            <label htmlFor="note" className="label font-medium text-black">
              Note:
            </label>
            <textarea
              name="paymentNotes"
              value={paymentNotes}
              onChange={handleOtherInputChange(setPaymentNotes)}
              className="input-field"
              rows="4"
              placeholder="Enter any additional notes"
              disabled={isLoading}
            />
          </div>
        </div>
        {/* Modal Footer */}
        <div className="flex justify-end gap-3 px-6 pb-6">
          <button
            onClick={handleClose}
            className="bg-[#E7633D]/90 text-sm text-white py-2 px-6 rounded-md hover:bg-[#E7633D] transition-all duration-300"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="bg-M-primary-color/90 text-sm text-white py-2 px-6 rounded-md hover:bg-M-primary-color transition-all duration-200"
            disabled={isLoading}
          >
            {billNo ? "Update" : "Save"}
          </button>
        </div>

        <AddMedicineModal
          isOpen={addMedicineModalOpen}
          onClose={() => setAddMedicineModalOpen(false)}
          onSave={handleAddMedicine}
          categories={categories.options.map((cat) => ({ id: parseInt(cat.value), name: cat.label }))}
          groups={groups}
          companies={companies}
          units={units}
        />
      </div>
    </div>
  );
};

export default PurchaseMedicineModal;